import React, {Fragment, Suspense} from 'react';
import MasterLayout from "../../components/MasterLayout/MasterLayout";
import LazyLoader from "../../components/MasterLayout/LazyLoader";
import CategoryCreate from './../../components/Category/CategoryCreate';

const CategoryCreatePage = () => {
    return (
        <Fragment>
            <MasterLayout>
                <Suspense fallback={<LazyLoader/>}>
                    <CategoryCreate/>
                </Suspense>
            </MasterLayout>
        </Fragment>
    );
};

export default CategoryCreatePage;